import { useRef, type ReactNode } from 'react';
import { useFloatingBanner } from '../hooks/useFloatingBanner';

interface HeroProps {
  title: string;
  /** chips, e.g. ["1,234 photos", "Jul 22 – Jul 25, 2026", "3.4 GB"] */
  sub: string[];
  coverUrl?: string;
  actions?: ReactNode;
  /** replaces the title text inside the heading (e.g. an inline rename field) */
  heading?: ReactNode;
  /** anything that changes the banner's content/size; the banner re-measures when it changes */
  layoutKey: string;
}

/** Photo-backed page banner that floats as a slim bar under the header while scrolling. */
export function Hero({ title, sub, coverUrl, actions, heading, layoutKey }: HeroProps) {
  const ref = useRef<HTMLDivElement>(null);
  useFloatingBanner(ref, [layoutKey, coverUrl ? 1 : 0]);
  return (
    <div className="hero-wrap" ref={ref}>
      <div className="hero">
        {coverUrl && <img className="hero-bg" alt="" src={coverUrl} />}
        <div className="hero-in">
          <h1 title={title}>{heading ?? title}</h1>
          {sub.length > 0 && (
            <div className="hero-sub">
              {sub.map((s, i) => (
                <span key={i}>{s}</span>
              ))}
            </div>
          )}
        </div>
        {actions && <div className="hero-act">{actions}</div>}
      </div>
    </div>
  );
}
